import SettingDTO from 'dto/tenants/settingDTO';
import UserSetting, { UserSettings } from 'models/users/userSetting';

//the user settings share the API's SettingDTO wire type with the organization settings (name and value)
export function mapFromUserSettings(settingDTOs: SettingDTO[] | undefined): UserSettings {
  const settings = new UserSettings();
  settings.items = (settingDTOs ?? []).map((settingDTO) => {
    const newSetting = new UserSetting();
    newSetting.settingName = settingDTO.settingName;
    newSetting.settingValue = settingDTO.settingValue;

    return newSetting;
  });

  return settings;
}

export function mapToUserSetting(name: string, value: boolean): SettingDTO {
  const settingDTO = new SettingDTO();
  settingDTO.settingName = name;
  settingDTO.settingValue = value.toString();

  return settingDTO;
}
